import $ from 'jquery';
export default class PromotionCoupon {
    static init() {
        if (!$('.js__promotion-code-generator').length) {
            return;
        }
        $('#sylius_promotion_coupon_admin').on('change', () => {
            this.checkCouponGenerationButtonAvailability();
        });
        this.checkCouponGenerationButtonAvailability();
        $('.js__promotion-generate-btn').on('click', e => {
            const { url, type, sourceInput, codeInput } = $(e.currentTarget).data();
            PromotionCoupon.generateAdminCode(url, type, sourceInput, codeInput);
        });
    }
    static generateAdminCode(url, type, sourceInput, codeInput) {
        const $coupon = $(sourceInput).find(':selected');
        const $items = $('.js__promotion-code-generator').find('button, input').not('input:hidden');
        const { firstName, lastName, teamChannel } = $coupon.data();
        $.ajax({
            url: url,
            type: 'POST',
            data: {
                type: type,
                name: firstName,
                surname: lastName,
                teamChannel: teamChannel,
            },
            beforeSend: () => {
                $items.prop('disabled', true).addClass('loading');
            },
        })
            .done(result => {
            if (!this.isEmpty(result)) {
                $(codeInput).val(result);
            }
        })
            .always(() => {
            $items.prop('disabled', false).removeClass('loading');
        });
    }
    static isEmpty(str) {
        return !str;
    }
    static checkCouponGenerationButtonAvailability() {
        const $button = $('.js__promotion-generate-btn');
        if (!$button.length) {
            return;
        }
        const { sourceInput } = $button.data();
        if (this.isEmpty($(sourceInput).val())) {
            $button.prop('disabled', true);
        }
        else {
            $button.prop('disabled', false);
        }
    }
}
